import { compact } from 'lodash';

import { TEMPO } from 'context/BrandContext';
import { brandData } from 'helpers/BrandData';

const generateExpiresText = voucher => {
  if (!voucher.redemptionExpirationWeeks) return '';

  return `Full balance of offer expires in ${voucher.redemptionExpirationWeeks} weeks from your sign up date.`;
};

const generateUsaaText = () => {
  return 'A 50% discount will be applied to your first box (up to $60) and you will receive 15% off each future box (up to $60 per box).';
};

const generateIdMeStudentAlumniGovText = (voucher, brand) => {
  const firstDiscount = voucher.discounts?.find(discount => discount.orderNumber === 1);
  const secondDiscount = voucher.discounts?.find(discount => discount.orderNumber === 2);

  if (brand === TEMPO) {
    return `Your ID.me discount has been applied. You're saving ${firstDiscount.percentFormatted} on your first box (up to ${firstDiscount.maxAmountFormatted}) and ${secondDiscount.percentFormatted} on your next month (up to ${secondDiscount.maxAmountFormatted} per box).`;
  }

  return `Your ID.me discount has been applied. You're saving ${secondDiscount.percentFormatted} off your first ${voucher.discounts.length} boxes, up to ${secondDiscount.maxAmountFormatted} per box.`;
};

const generateIdMeDessertOfferText = firstDiscount => {
  return `An ID.me ${firstDiscount.percentFormatted} discount (up to ${firstDiscount.maxAmountFormatted}) and free shipping have been applied to your first order. An ID.me 10% discount (up to $60) will be applied to future orders. Offer is 1 free item/box with an active meal subscription. Offer ends if customer skips 6 straight weeks or if subscription is cancelled or paused. No reinstatement upon reactivation. Offer may be limited or modified any time. Shipping fee applies on deliveries after the 1st box.`;
};

const generateIdMeStandardText = firstDiscount => {
  return `Your ID.me discount has been applied. You're saving ${firstDiscount.percentFormatted} on your first box (up to ${firstDiscount.maxAmountFormatted}) and 10% on future orders.`;
};

const generateIdMeMilitaryHealthTeacherText = voucher => {
  const firstDiscount = voucher.discounts?.find(discount => discount.orderNumber === 1);

  if (voucher.code.startsWith('4DME')) {
    return generateIdMeDessertOfferText(firstDiscount);
  }

  return generateIdMeStandardText(firstDiscount);
};

const generateDiscountText = voucher => {
  const expiresText = generateExpiresText(voucher);
  let behavioralDiscountText = '';

  if (voucher.freeForLifeDiscounts) {
    behavioralDiscountText = voucher.freeForLifeDiscounts
      .map(item => item.promoAppliedText)
      .join(' ');
  }

  return compact([voucher.promoAppliedText, behavioralDiscountText, expiresText]).join(' ');
};

const generateDefaultText = brand => {
  return `Get $10 off your second order when you sign up for ${brandData(brand).displayName}. Offer expires in 90 days from sign up date.`;
};

/**
 * Main function to generate promo applied text based on voucher type
 */
export const generatePromoAppliedText = (voucher, brand) => {
  if (!voucher) return '';

  if (voucher.isUsaa) {
    return generateUsaaText();
  }

  if (voucher.isIdMeStudentAlumniGov) {
    return generateIdMeStudentAlumniGovText(voucher, brand);
  }

  if (voucher.isIdMeMilitaryHealthTeacher) {
    return generateIdMeMilitaryHealthTeacherText(voucher);
  }

  if (voucher.discounts?.length) {
    return generateDiscountText(voucher);
  }

  return generateDefaultText(brand);
};
